var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-month-picker',{attrs:{"placeholder":"选择月份"},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }